import { useCallback, useMemo } from 'react';

import { UseConfirmUpdatesModalParams } from '../ConfirmUpdatesModal.types';
import { PropertyChangeItem } from '../SyncUpdatesModal.types';
import { groupChangesForConfirm } from '../utils/groupChanges';

export const useConfirmUpdatesModal = ({ selectedProperties, allChanges }: UseConfirmUpdatesModalParams) => {
  const groups = useMemo(() => groupChangesForConfirm(allChanges), [allChanges]);

  const isAppliedToLowerOrgs = useCallback((property: PropertyChangeItem): boolean => {
    if (selectedProperties.includes(property.propertyName)) return true;

    if (!property.isRoot && property.groupType) {
      const rootProperty = allChanges.find(
        (p) => p.isRoot && p.groupType === property.groupType
      );
      if (rootProperty && selectedProperties.includes(rootProperty.propertyName)) return true;
    }

    return false;
  }, [selectedProperties, allChanges]);

  return { groups, selectedProperties, isAppliedToLowerOrgs };
};
